export default {"src":"/_next/static/media/search-51x53.3455bcb9.svg","height":53,"width":51,"blurWidth":0,"blurHeight":0};